import { classNames } from '@dimjs/utils';
import { FC, memo } from 'react';
import { ArrowIcon } from '../icon';
import { IphoneBottomAdaptive } from '../iphone-bottom-adaptive';
import { ModalDrawer, ModalDrawerProps } from '../modal-drawer';
import { Space } from '../space';
import { NativeProps } from '../utils/native-props';
import './styles/modal.less';
import { Keyboard, KeyboardProps } from './view';

export type KeyboardModalProps = {
  title?: string | JSX.Element;
  visible?: boolean;
  keyboardProps: KeyboardProps;
  modalProps?: Omit<ModalDrawerProps, 'visible' | 'className' | 'title' | 'closeIcon' | 'onClose'>;
  closeIcon?: boolean;
  onClose: () => void;
} & NativeProps;

export const KeyboardModalInner: FC<KeyboardModalProps> = (props) => {
  const renderHeader = () => {
    if (!props.title && !props.closeIcon) {
      return null;
    }
    if (!props.closeIcon) {
      return <div className="v-keyboard-modal-title">{props.title}</div>;
    }
    return (
      <Space
        justifyContent={props.title ? 'space-between' : 'center'}
        className="v-keyboard-modal-head"
        onClick={props.onClose}
      >
        <span>{props.title}</span>
        {props.closeIcon && <ArrowIcon direction="bottom" size={25} />}
      </Space>
    );
  };

  return (
    <ModalDrawer
      mask={false}
      {...props.modalProps}
      visible={props.visible}
      className={classNames('v-keyboard-modal', props.className)}
      onClose={props.onClose}
      forceRender={true}
      duration={200}
      closeIcon={false}
    >
      {renderHeader()}
      <Keyboard {...props.keyboardProps} />
      <IphoneBottomAdaptive />
    </ModalDrawer>
  );
};

KeyboardModalInner.defaultProps = {
  closeIcon: true,
};

export const KeyboardModal = memo(KeyboardModalInner, (prevProps, nextProps) => {
  if (prevProps.visible !== nextProps.visible || prevProps.title !== nextProps.title) {
    return false;
  }
  return true;
});
